export interface RoleEntity {
  id: string;
  name: string;
  access: string[];
}

export namespace RoleEntity {
  export function fromJSON(json: any[]): RoleEntity[] {
    return json.map(
      (e): RoleEntity => ({
        id: e.roleID,
        name: e.roleName,
        access: (e.access as string).split(",") || [],
      })
    );
  }
}
